import { Component, input, signal, viewChild } from '@angular/core';
import { RidButton } from '../../components/rid-button/rid-button';
import { RidCompressableKlankCard } from '../../components/rid-compressable-klank-card/rid-compressable-klank-card';
import { RidFunctionalSyllabicKeyboard } from '../../components/rid-functional-syllabic-keyboard/rid-functional-syllabic-keyboard';
import { RidMechanicBackground } from '../../components/rid-mechanic-background/rid-mechanic-background';
import { RidMechanicContent } from '../../components/rid-mechanic-content/rid-mechanic-content';
import { RidMechanicWrapper } from '../../components/rid-mechanic-wrapper/rid-mechanic-wrapper';
import { RidOverlayFeedback } from '../../components/rid-overlay-feedback/rid-overlay-feedback';
import { RidSyllabicCard } from '../../components/rid-syllabic-card/rid-syllabic-card';
import { TKeyboardLayout, TKeyValue } from '../../components/rid-syllabic-keyboard/rid-syllabic-keyboard.utils';
import { RidTextInput } from '../../components/rid-text-input/rid-text-input';
import { RidTopBar } from '../../components/rid-top-bar/rid-top-bar';
import { RidVerticalSpacer } from '../../components/rid-vertical-spacer/rid-vertical-spacer';
import { IconBackspace } from '../../icons/i-backspace';
import { IconEnter } from '../../icons/i-enter';

@Component({
  selector: 'rid-syllabic-keyboard-freeform',
  imports: [
    RidMechanicBackground,
    RidMechanicWrapper,
    RidTopBar,
    RidMechanicContent,
    RidFunctionalSyllabicKeyboard,
    RidTextInput,
    RidVerticalSpacer,
    RidCompressableKlankCard,
    RidSyllabicCard,
    RidButton,
    RidOverlayFeedback,
    IconBackspace,
    IconEnter,
  ],
  templateUrl: './rid-syllabic-keyboard-freeform.html',
  host: {
    class: 'block',
  },
})
export class RidSyllabicKeyboardFreeform {
  layout = input<TKeyboardLayout | undefined>();
  mode = input<'GROUP' | 'KLANK' | 'BOTH'>('BOTH');
  mask = input<TKeyValue[] | undefined>();

  keyboardComp = viewChild.required<RidFunctionalSyllabicKeyboard>('keyboardComp');

  version = signal(0);

  okay() {
    this.keyboardComp().clear();

    this.version.set(this.version() + 1);
  }
}
